var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"come-back-to-admin__container"},[_c('el-button',{staticClass:"come-back-to-admin__container--button",attrs:{"size":"mini","type":"danger"},on:{"click":_vm.handleClickBtn}},[_vm._v("\n    Вернуться к СЕО\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }